import type { OlProps } from "@components/OlProps.js";
import type { Tenant } from "@core/schema/Tenant.js";
import { fastestYearsInBusiness } from "./fastestFounded.js";

export function getConnectWithFastestBenefits(tenant: Tenant): OlProps[] {
	return [
		{ title: "Na míru", desc: "Neděláme krabicová řešení, ale vyvíjíme 100% na míru." },
		{ title: "Zkušenosti", desc: `Máme za sebou 300+ projektů a více než ${fastestYearsInBusiness} let zkušeností.` },
		{ title: "Levný provoz", desc: "Software vyvíjíme efektivně bez serverů." },
		{ title: "Kvalita", desc: "Razíme kvalitu, ne kvantitu." },
	];
}
